import { FormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { UtilsService } from './../../../services/utils.service';
import { ErrorResponse } from './../../../models/error.model';
import { FormsService } from './../../../services/forms.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CustomForm } from 'src/app/models/custom-form.model';
import { Document } from 'src/app/models/document.model';

@Component({
    selector: 'app-tenant-custom-form',
    templateUrl: './tenant-custom-form.component.html',
    styleUrls: ['./tenant-custom-form.component.scss']
})
export class TenantCustomFormComponent implements OnInit {

    formConfig: CustomForm;

    fieldsArray = new UntypedFormArray([], []);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private formsService: FormsService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params.id) {
                this.formsService.getFormById(params.id).subscribe(form => {
                    form.campos.forEach(campo => {
                        this.fieldsArray.push(new UntypedFormControl('', [Validators.required]));
                    });
                    this.formConfig = form;
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener formulario', error.error?.descripcion));
            }
        });
    }

    submit() {
        this.fieldsArray.markAllAsTouched();
        if (this.fieldsArray.valid) {
            let uploadingFiles = 0;
            let errors = 0;
            const filesToUpload = this.formConfig.campos.forEach((field, index) => {
                if (field.tipo === 'UPLOAD') {
                    const document: Document = this.fieldsArray.at(index).value;
                    if (document?.archivo) {
                        uploadingFiles++;
                        this.formsService.uploadDocument(this.formConfig.id, document.archivo, field.id)
                        .then(_ => {})
                        .catch((error: ErrorResponse) => {
                            this.utilsService.alert('Error al subir archivo' + document.nombreArchivo, error.error?.descripcion);
                            errors++;
                        })
                        .finally(() => {
                            uploadingFiles--;
                            if (uploadingFiles === 0 && !errors) {
                                this.closeForm();
                            }
                        });
                    }
                }
            });
            if (uploadingFiles === 0 && !errors) {
                this.closeForm();
            }
        }
    }

    closeForm() {
        this.formsService.closeForm(
            this.formConfig.id,
            this.formConfig.campos
                .map((value, index) => ({ value, index }))
                .filter(field => field.value.tipo === 'INPUT')
                .map((field) => ({ id: field.value.id, valor: this.fieldsArray.value[field.index] }))
        ).subscribe(
            _ => this.router.navigate(['listo'], { relativeTo: this.route }),
            (error: ErrorResponse) => this.utilsService.alert('Error al enviar formulario', error.error?.descripcion)
        );
    }

    cancelForm() {
        this.formsService.cancelForm(this.formConfig.id).subscribe(
            _ => this.utilsService.alert('Mensaje enviado', 'Hemos avisado a su agente que no cuenta con la información necesaria, se pondrá en contacto con usted a la brevedad.'),
            (error: ErrorResponse) => this.utilsService.alert('Error al enviar mensaje', error.error?.descripcion)
        );
    }

}
